import { useState } from 'react';

import { observer } from 'mobx-react-lite';

import { api } from 'api';
import { useStore } from 'models/Provider';

import { ForgotPassword } from './forgot-password';

function ForgotPasswordPage() {
  const { t } = useStore();
  const [state, setState] = useState({
    email: '',
    error: '',
    disable: false,
    submitted: false,
  });

  function handleChange(name, value) {
    setState((old) => ({ ...old, [name]: value }));
  }

  async function resetPassword() {
    setState((old) => ({ ...old, error: '', disable: true }));
    const response = await api.users.resetPassword({ email: state.email });
    if (!response.error) {
      setState((old) => ({ ...old, submitted: true }));
    } else {
      setState((old) => ({ ...old, error: t('forgotpw.reseterror'), disable: false }));
    }
  }

  return (
    <ForgotPassword
      t={t}
      email={state.email}
      onChange={handleChange}
      onSubmit={resetPassword}
      error={state.error}
      disableSubmit={state.disable}
      submitted={state.submitted}
    />
  );
}

export default observer(ForgotPasswordPage);
